import { Form, Modal, Switch } from "antd";
import { useQuote } from "../QuoteProvider";
import { useState } from "react";
import Link from "antd/es/typography/Link";
import { useTranslation } from "react-i18next";

/** DOM id of the Terms acceptance row, used by StepContact's disabled-CTA hint
 *  to scroll the switch into view when the patient hasn't accepted yet. */
export const TERMS_AGREEMENT_ANCHOR_ID = "quote-contact-terms-agreement";

const QuotePrivacyPolicy = () => {
  // @ts-ignore - useTranslation with namespace parameter
  const { t } = useTranslation("quote");
  const quoteData = useQuote();
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Form
      style={{ marginBottom: "5px" }}
      layout="horizontal"
      form={form}
      initialValues={{ layout: "horizontal" }}
    >
      <Modal
        open={isOpen}
        footer={null}
        width={800}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div>
          <h2>Privacy Compliance Notification</h2>
          <p>
            {" "}
            We want you to know we take the protection of your Personal Health
            Information (PHI) very seriously. We want you to know all of our
            employees; managers, doctors, and affiliates continually undergo
            training so that they may understand and comply with government
            rules and regulations regarding the Health Insurance Portability and
            Accountability Act (HIPAA) with particular emphasis on the “Privacy
            Rule”. We strive to achieve the very highest standards of ethics and
            integrity in performing services for our patients. It is our policy
            to properly determine appropriate uses of PHI in accordance with the
            governmental rules, laws and regulations. We want to ensure that our
            practice never contributes in any way to the growing problems of
            improper disclosure of PHI. As part of this plan, we have
            implemented a Compliance Program that we believe will help up
            prevent any inappropriate use of PHI and we welcome your input
            regarding any service problems, so that we may remedy the situation
            promptly.
          </p>

          <h2>Patient Consent Form</h2>

          <p>
            The Department of Health and Human Services has established a
            “Privacy Rule” to help insure that personal health care information
            is protected for privacy. The Privacy Rule was also created in order
            to provide a standard for certain health care providers to obtain
            patients’ consents for uses and disclosures of health information
            about the patient to carryout treatment, payment, or health care
            operations.
            <br />
          </p>

          <p>
            As our patient, we want you to know that we respect the privacy of
            your personal medical records and will do all we can to secure and
            protect that privacy. We strive to always take reasonable
            precautions to protect your privacy. When it is appropriate and
            necessary, we provide the minimum necessary information to only
            those we feel are in need of your health care information and
            information about treatment, payment or healthcare operations, in
            order to provide health care that is in your best interest.
            <br /> We also want you to know that we support full access to your
            personal medical records. We may have indirect treatment
            relationships with you (such as laboratories that only interact with
            physicians and not patients), and may have to disclose personal
            health information for purposes of treatment, payment, or health
            care operations. These entitles are most often not required to
            obtain patient consent.
            <br />{" "}
          </p>

          <p>
            You may refuse to consent to the use of disclosure of your personal
            health information, but this must be in writing. Under this law, we
            have the right to refuse to treat you should you choose to refuse to
            disclose your Personal Health Information (PHI). If you choose to
            give consent in this document, at some future time you may request
            to refuse all or part of your PHI. You may not revoke actions that
            have already been taken which relied on this or a previously signed
            consent.
            <br />{" "}
          </p>

          <p>
            If you have any objections to this form, please ask to speak with
            our HIPAA Compliance Officer. You have the right to review our
            privacy notice, to request restrictions and revoke consent in
            writing after you have reviewed our privacy notice.
          </p>

          <h2>Unsecure Communication Policy</h2>

          <p>
            Top Aesthetics, their staff, and affiliates (Dr. Miami International
            Group Squad members) are happy to communicate with you via
            email/text/virtual platforms (such as FaceTime) when you have
            questions or concerns, and privacy is not guaranteed. By signing
            below, you are stating that you’ve been notified of the risks,
            benefits and alternatives of the use of email/text/virtual platforms
            for communication with Top Aesthetics, and/or their staff or
            affiliates, you accept the responsibilities and/or consequences that
            may arise from such communication, and you agree to hold Top
            Aesthetics and their staff harmless should such an interception
            occur.
          </p>
        </div>
      </Modal>

      {/* Required: acceptance of our Terms & Privacy Policy. This is NOT an
          SMS opt-in — it only gates use of the service, so it may be mandatory.
          It sets ONLY hipaaAgreement (no longer flips the SMS opt-in). */}
      <Form.Item style={{ marginTop: "10px", textAlign: "left" }}>
        <label
          // Scroll anchor for StepContact's disabled-CTA hint — a plain DOM id
          // on a plain <label>, so antd never clones it away.
          id={TERMS_AGREEMENT_ANCHOR_ID}
          style={{
            display: "flex",
            alignItems: "flex-start",
            cursor: "pointer",
            gap: "10px",
          }}
        >
          <Switch
            style={{ marginTop: "3px" }}
            checked={quoteData.hipaaAgreement}
            onChange={(value) => quoteData.setHipaaAgreement(value)}
          />
          <span>
            {t("contact.privacyAgreement")}{" "}
            <a
              target="_blank"
              href="https://topaesthetics.com/terms-and-conditions/"
              onClick={(e) => e.stopPropagation()}
              style={{ color: "#0066cc", textDecoration: "underline" }}
            >
              Terms
            </a>{" "}
            {t("contact.privacyAnd")}{" "}
            <a
              target="_blank"
              href="https://topaesthetics.com/privacy-policy/"
              onClick={(e) => e.stopPropagation()}
              style={{ color: "#0066cc", textDecoration: "underline" }}
            >
              Privacy Policy
            </a>
            {t("contact.privacyAgreementEnd")}
          </span>
        </label>
      </Form.Item>

      {/* Optional SMS/voice opt-in — kept SEPARATE from the Terms acceptance
          above and NOT required to proceed, so it's a genuine opt-in. A2P 10DLC
          (reason 803) rejects a forced/bundled mandatory consent box; this is
          its own toggle, OFF by default, that sets ONLY optInText. Styled to
          match the Terms Switch above (top-aligned to the text). Links
          stopPropagation so opening Terms/Privacy doesn't toggle it. */}
      <Form.Item
        style={{ marginTop: "4px", marginBottom: 0, textAlign: "left" }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "flex-start",
            cursor: "pointer",
            gap: "10px",
          }}
        >
          <Switch
            style={{ marginTop: "3px" }}
            checked={quoteData.optInText}
            onChange={(value) => quoteData.setOptInText(value)}
          />
          <span style={{ fontSize: "13px", lineHeight: 1.3 }}>
            {t("contact.smsConsent")}{" "}
            <a
              target="_blank"
              href="https://topaesthetics.com/terms-and-conditions/"
              onClick={(e) => e.stopPropagation()}
              style={{ color: "#0066cc", textDecoration: "underline" }}
            >
              Terms
            </a>{" "}
            {t("contact.privacyAnd")}{" "}
            <a
              target="_blank"
              href="https://topaesthetics.com/privacy-policy/"
              onClick={(e) => e.stopPropagation()}
              style={{ color: "#0066cc", textDecoration: "underline" }}
            >
              Privacy Policy
            </a>
            {t("contact.privacyAgreementEnd")}{" "}
            <strong>{t("contact.optional")}</strong>
          </span>
        </label>
      </Form.Item>

      {/* reCAPTCHA attribution (bot-score Phase 1, 2026-09-13). Google allows
          hiding the floating badge ONLY when this notice is shown in the
          form's fine print, so it is rendered unconditionally next to the
          submit — the badge itself is hidden by the style utils/
          funnelRecaptcha.ts injects with api.js. Same wording the PHP sites
          use (sites/topaesthetics.com/assets/inc/footer.php). */}
      <div
        style={{
          marginTop: "8px",
          fontSize: "11px",
          lineHeight: 1.4,
          color: "#8a8a8a",
          textAlign: "left",
        }}
      >
        {t("contact.recaptchaNoticeStart")}{" "}
        <Link
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          {t("contact.recaptchaPrivacyPolicy")}
        </Link>{" "}
        {t("contact.recaptchaAnd")}{" "}
        <Link
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          {t("contact.recaptchaTerms")}
        </Link>{" "}
        {t("contact.recaptchaNoticeEnd")}
      </div>
    </Form>
  );
};

export default QuotePrivacyPolicy;
